import React from 'react'
import EbookData from '../ebook.json'
import ServerInfo from '../server.json'
import HorizontalList from '../common/HorizontalList'
import '../App.css';
import {
    Card,
    CardSection,
}from '../common'
import Ebook from '../common/Ebook'
import ShowBooks from '../common/ShowBooks'
import HeaderBar from '../common/HeaderBar'
import BottomBar from '../common/BottomBar'
import {connect } from 'react-redux'
import axios from 'axios'

class ResetPassword extends React.Component {
    // constructor(props) {
    //     super(props);

    //     this.state = {
    //         password: '',
    //         token: null,
    //         serverAddress: ServerInfo.serverAddress,
    //     }
    // }

    state = {
        password: '',
        token: null,
        serverAddress: ServerInfo.serverAddress, 
    }

    componentDidMount(){
        console.log('componentDidMount')
        this.checkUrlLink()
    }

    render() {
            return(                          
                <Card>
                    <HeaderBar history={this.props.history}></HeaderBar>
                    <div style={{padding: '80px 10px', textAlign:"center"}}>                  
                        <div style={{fontSize: '20px'}}>
                            Reset Password
                        </div>
                        <div style={styles.heading1}>
                            <div>
                                <input name="password" placeholder="New Password" style={styles.inputText} onChange={this.changeHandler} onKeyPress={this.handleKeyPress} />
                            </div>
                            {/* <div>
                                <input name="password" placeholder="Confirm Password" style={styles.inputText}/>
                            </div> */}
                            <div style={{paddingTop:"20px"}}>
                                <button style={styles.button} onClick={() => this.submit()}>Confirm</button>
                            </div>
                        </div>
                    </div>
                    <BottomBar history={this.props.history}></BottomBar>
                </Card>
            )
    }

    handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            this.submit()
        //   console.log('enter press here! ')
        }
      }
    
    changeHandler = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    submit()
    {
        console.log(this.state.password)
        if(this.state.email != "")
        {
            var self = this
            var bodyFormData = new FormData();
            bodyFormData.append("password", this.state.password);
            bodyFormData.append("token", this.state.token);
        
            axios({
                method: 'post',
                url: this.state.serverAddress+'/user/resetPassword',
                // url: 'http://localhost:8080/user/resetPassword',
                data: bodyFormData,
                config: {headers: {
                    "Content-Type": "multipart/form-data"}
                    }
            })
            .then(response => {
                if(response.data.status == "1") // success
                {
                    console.log(response)
                    window.location.href = "/requestreset"
                }
                else
                {
                    console.log(response)
                }
            })
            .catch(error => {
                console.log(error)
            })
        }
    }

    

    checkUrlLink()
    {
        console.log('checkUrlLink: 0')
        var tempToken = window.location.search.replace("?","")
        tempToken = tempToken.split("=")[1]

        console.log('checkUrlLink: 1')
        if(window.location.href.includes("?token") ){
            // console.log(tempToken)
            console.log('token: ',window.location.href.includes("?token")+' : '+tempToken)
            console.log('checkUrlLink: 2')
            axios({
                method: 'get',
                url: this.state.serverAddress+'/user/checkToken/' + tempToken,
                //url: 'http://localhost:8080/user/checkToken/' + tempToken,
                responseType: 'stream'
            })
            .then(response => {
                console.log('checkUrlLink: 3')
                if(response.data.status == "1")
                {
                    // console.log(response)
                    console.log('checkUrlLink: 4')
                    this.setState({
                        token : tempToken
                    })
                }else {
                    console.log('checkUrlLink: 5')
                    window.location.href = "/"
                }
                console.log('checkUrlLink: 6')
            })
            .catch(error => {
                console.log(error)
            })

        }
        else
        { 
            window.location.href = "/"
        }
    }

}

const styles = {
    inputText: {
        minWidth: "300px",
        // size:"50",
        // textAlign: "center",
        // margin : "1vmin",
        padding: "12px",
        // borderRadius: "1vmin"
        // border: "none",
        // backgroundColor:"#f9f9f9"
    },

    button: {
        cursor: 'pointer',
        backgroundColor: "#1e7b85",
        border: "none",
        color: "white",
        // margin : "1vmin",
        // marginTop:"2vmin",
        padding: "5px",
        // textAlign: "center",
        // textDecoration: "none",
        // display: "inline-block",
        fontSize: "14px",
        width: "100px",
        height: "40px",
        borderRadius: '4px'
    },

    heading1: {
        // backgroundColor: "#527AAE",
        // padding: "1vmin",
        // textAlign: "center",
        fontSize: "14px",
        color: "black",
        padding: "20px"
        // fontFamily: 'Myriad Pro Regular'
    },
}

export default connect(state => state)(ResetPassword)